export const automationImages = {
  pause_icon_v2: 'assets/img/automation-icons/pause.svg.svg',
  progress_icon: 'assets/img/automation-icons/progress.svg',
  progress_once_icon: 'assets/img/automation-icons/static/progress-completed-once.svg',
  progress_completed_icon: 'assets/img/automation-icons/static/progress-completed.svg',
  progress_uncompleted_icon: 'assets/img/automation-icons/static/progress-uncompleted.svg',
  save_icon: 'assets/img/automation-icons/static/save.svg',
  network_tree_icon: 'assets/img/automation-icons/static/network-tree.svg',
  zoom_out_icon: 'assets/img/automation-icons/static/zoom-out.svg',
  zoom_in_icon: 'assets/img/automation-icons/static/zoom-in.svg',
  reset_icon: 'assets/img/automation-icons/static/reset.svg',
  pin_icon: 'assets/img/automation-icons/static/pin.svg',
  copy_icon: 'assets/img/automation-icons/static/copy.svg',

  alert_icon: 'assets/img/automation-icons/Alert.svg',
  attach_icon: 'assets/img/automation-icons/Attach.svg',
  contact_icon: 'assets/img/automation-icons/Contact.svg',
  customerCare_icon: 'assets/img/automation-icons/CustomerCare.svg',
  delete_icon: 'assets/img/automation-icons/Delete.svg',
  eManager_icon: 'assets/img/automation-icons/E-manager.svg',
  edit_icon: 'assets/img/automation-icons/Edit.svg',
  email_icon: 'assets/img/automation-icons/Email.svg',
  folderLight_icon: 'assets/img/automation-icons/FolderLight.svg',
  help_icon: 'assets/img/automation-icons/Help.svg',
  leadManagement_icon: 'assets/img/automation-icons/LeadManagement.svg',
  library_icon: 'assets/img/automation-icons/Library.svg',
  newCreate_icon: 'assets/img/automation-icons/NewCreate.svg',
  notifications_icon: 'assets/img/automation-icons/Notifications.svg',
  peoplesTwo_icon: 'assets/img/automation-icons/PeoplesTwo.svg',
  project_icon: 'assets/img/automation-icons/Project.svg',
  properties_icon: 'assets/img/automation-icons/Properties.svg',
  task_icon: 'assets/img/automation-icons/Task.svg',
  update_icon: 'assets/img/automation-icons/Update.svg',
  user_icon: 'assets/img/automation-icons/User.svg',
  view_icon: 'assets/img/automation-icons/View.svg',
};
